import { useTranslation } from 'react-i18next';
import { Card, ListGroup } from 'react-bootstrap';

const imgStyle = { height: 260, objectFit: 'cover' };

const DonateToUs = () => {
    const { t } = useTranslation();

    return (
        <div className="container mt-5 px-3">
            <h1
                className="text-center m-4"
                style={{ color: '#58c459', fontWeight: 600 }}
            >
                {t('donate-to-us.subtitle')}
            </h1>
            <p>{t('donate-to-us.details')}</p>
            <p>See a list of items below for more details:</p>

            {/* Responsive row with spacing */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-5">
                {/* Food */}
                <div className="col d-flex">
                    <Card className="w-100 h-100 shadow-sm">
                        <Card.Img variant="top" src="../img/dog-food.jpg" style={imgStyle} />
                        <Card.Body>
                            <Card.Title
                                className="text-center"
                                style={{ color: '#58c459', fontWeight: 600 }}
                            >
                                {t('donate-to-us.food.title')}
                            </Card.Title>
                            <ListGroup variant="flush">
                                <ListGroup.Item>{t('donate-to-us.food.list-1')}</ListGroup.Item>
                                <ListGroup.Item>{t('donate-to-us.food.list-2')}</ListGroup.Item>
                                <ListGroup.Item>{t('donate-to-us.food.list-3')}</ListGroup.Item>
                                <ListGroup.Item>{t('donate-to-us.food.list-4')}</ListGroup.Item>
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </div>

                {/* Accessories */}
                <div className="col d-flex">
                    <Card className="w-100 h-100 shadow-sm">
                        <Card.Img variant="top" src="../img/accessories-dog.jpg" style={imgStyle} />
                        <Card.Body>
                            <Card.Title
                                className="text-center"
                                style={{ color: '#58c459', fontWeight: 600 }}
                            >
                                {t('donate-to-us.accessories.title')}
                            </Card.Title>
                            <ListGroup variant="flush">
                                {Array.from({ length: 10 }).map((_, i) => (
                                    <ListGroup.Item key={i}>
                                        {t(`donate-to-us.accessories.list-${i + 1}`)}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </div>

                {/* Medicines */}
                <div className="col d-flex">
                    <Card className="w-100 h-100 shadow-sm">
                        <Card.Img variant="top" src="../img/medical-device.jpg" style={imgStyle} />
                        <Card.Body>
                            <Card.Title
                                className="text-center"
                                style={{ color: '#58c459', fontWeight: 600 }}
                            >
                                {t('donate-to-us.medicines.title')}
                            </Card.Title>
                            <ListGroup variant="flush">
                                {Array.from({ length: 8 }).map((_, i) => (
                                    <ListGroup.Item key={i}>
                                        {t(`donate-to-us.medicines.list-${i + 1}`)}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </div>

                {/* Cleaning */}
                <div className="col d-flex">
                    <Card className="w-100 h-100 shadow-sm">
                        <Card.Img variant="top" src="../img/clean-tool.jpg" style={imgStyle} />
                        <Card.Body>
                            <Card.Title
                                className="text-center"
                                style={{ color: '#58c459', fontWeight: 600 }}
                            >
                                {t('donate-to-us.cleaning.title')}
                            </Card.Title>
                            <ListGroup variant="flush">
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <ListGroup.Item key={i}>
                                        {t(`donate-to-us.cleaning.list-${i + 1}`)}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default DonateToUs;
